import { SceneBase } from '@jollywise/jollygoodgame';
import { KEYS } from 'game/constants/SceneConstants';
import { FONT_BASE } from '../constants/AppFonts';

export class Onboarding extends SceneBase {
  constructor() {
    super({ key: KEYS.Onboarding, active: false });
  }

  preload() {}

  init(config) {
    this._config = config.data;
    this.obData = config.data.content[config.data.id];
    this.dialogue = this.obData.dialogue;
    this.onComplete = config.onComplete;
    this.onCompleteScope = config.onCompleteScope;
  }

  create() {
    super.create();

    this.add.rectangle(840, 360, 1680, 720, 0x140d17, 0.8);
    this.add.image(840, 720, 'shared_ui', 'subtitle_bar').setOrigin(0.5, 1);

    this.textField = this.add
      .text(840, 640, '', {
        fontFamily: FONT_BASE.LIGHT,
        fontSize: 32,
        color: '#ffffff',
        align: 'center',
        wordWrap: { width: 760 },
      })
      .setOrigin(0.5, 0.5);

    this.character = this.add
      .image(this.obData.character_x, 558, 'shared_ui', this.obData.character)
      .setOrigin(0.5, 1);

    this.line = 0;
    this.showNextLine();
  }

  showNextLine() {
    this.removeTimeout();
    const dialogue = this.dialogue[this.line];
    this.textField.setText(dialogue.text);
    this.line++;
    if (this.line >= this.dialogue.length) {
      this.timeout = this.time.delayedCall(dialogue.time, this.game.closeOnboarding, [], this.game);
    } else {
      this.timeout = this.time.delayedCall(dialogue.time, this.showNextLine, [], this);
    }
  }

  removeTimeout() {
    if (this.timeout) {
      this.timeout.remove();
      this.timeout = null;
    }
  }

  shutdown() {
    this.removeTimeout();
    this.textField = null;
    this.character = null;
    super.shutdown();
  }
}
